export const fieldsToUpdateFromApiResponse = [
  'isValid',
  'validationErrors',
  'subLabel',
  'webhookUrl',
  'unsaved',
  'availableActions',
  'propertyDataType',
  'conditions',
];

export const fieldsUpdatedAfterSave = (step) => {
  return fieldsToUpdateFromApiResponse.reduce((acc, field) => {
    switch (field) {
      case 'unsaved':
        return {
          ...acc,
          unsaved: false,
        };
      default:
        return {
          ...acc,
          [field]: step[field],
        };
    }
  }, {});
};
